/** Remonte les erreurs du navigateur à l'API (dev/staging : /api/v1/_client-log ; 404 ignoré en prod). */
export function installClientLog(): void {
  let sent = 0;
  const send = (message: string, stack?: string) => {
    if (sent++ > 20) return;
    fetch('/api/v1/_client-log', {
      method: 'POST',
      keepalive: true,
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        level: 'error',
        message: message.slice(0, 2000),
        ...(stack ? { stack: stack.slice(0, 6000) } : {}),
        url: location.pathname + location.hash,
      }),
    }).catch(() => undefined);
  };
  window.addEventListener('error', (e) => send(e.message, e.error instanceof Error ? e.error.stack : undefined));
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    send(r instanceof Error ? r.message : String(r), r instanceof Error ? r.stack : undefined);
  });
}
